import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-pickslip.svg";
import * as styles from "./Icon.module.scss";

type PickslipProps = React.SVGProps<SVGSVGElement>;

export const Pickslip = ({ className, ...props }: PickslipProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
